/*
  icon-assignment
  icon-dashboard
  icon-devices
  icon-perm_contact_calendar
  icon-assessment
*/
import locale from './locale';
import __R, { userCan, isBasicUser } from 'containers/__R'
import {alert} from 'util/alert';

export const fullScreenPath = [
  '/',
  '/upgrade',
  '/privacy-en',
  '/privacy-cn',
  '/print-schedule',
  '/account-settings',
  '/website'
];

export const invalidUserAllowedPath = [
  '/',
  '/privacy-en',
  '/privacy-cn',
  '/account-settings',
]
export default function() {
  // this here is Main.js component

  return [
    {
      name: 'dashboard',
      label: __("Home", locale),
      icon: "icon-dashboard",
      active: true,
      subMenus: [
        {
          label: __("Dashboard", locale),
          path: '/dashboard',
          default: true,
          active: true,
          // disabled: ()=>{
          //   return !userCan('announcement_channel')
          // }
        },
        {
          label: __("Activity Log", locale),
          path: "/logs",
          onClick: ()=>{
            if(isBasicUser()){
              alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', locale))
            }
          },
          disabled: ()=>{
            return !userCan('operation_log_channel') || isBasicUser()
          }
        },
      ],
    },
    {
      name: 'teaching',
      label: __("Administration", locale),
      icon: "icon-assignment",
      subMenus: [
        {
          label: __("Schedules", locale),
          path: "/schedule",
          onClick: ()=>{
            // default
          },
          disabled: ()=>{
            return !userCan('timetable_channel')
          }
        },
        {
          label: __("Students", locale),
          path: "/student",
          activePaths: ['/student-settings'],
          disabled: ()=>{
            return !userCan('student_channel')
          }
        },
        {
          label: __("Classes", locale),
          path: "/class",
          activePaths: ['/class-detail/:classId'],
          disabled: ()=>{
            return !userCan('class_channel')
          }
        },
        {
          label: __("Private Classes", locale),
          path: "/one_one",
          activePaths: ['/class-one-detail/:classId'],
          disabled: ()=>{
            return !userCan('private_class_channel')
          }
        },
        {
          label: __("Teachers", locale),
          path: "/teacher",
          disabled: ()=>{
            return !userCan('teacher_channel')
          }
        },
        {
          label: __("Classrooms", locale),
          path: "/classroom",
          disabled: ()=>{
            return !userCan('classroom_channel')
          }
        },
        {
          label: __("Announcements", locale),
          path: "/announcement",
          disabled: ()=>{
            return !userCan('announcement_channel')
          }
        },
      ],
    },
    {
      name: 'finance',
      label: __("Finance", locale),
      icon: "icon-assessment",
      subMenus: [
        {
          label: __("Statement Detail", locale),
          default: true,
          path: "/finance",
          disabled: ()=>{
            return !userCan('finance_channel')
          }
        },
        {
          label: __("Monthly Summary", locale),
          path: "/monthly-finance",
          disabled: ()=>{
            return !userCan('finance_channel')
          }
        },
      ]
    },
    {
      name: 'marketing',
      label: __("Marketing", locale),
      icon: "icon-perm_contact_calendar",
      subMenus: [
        {
          label: __("Posters", locale),
          default: true,
          path: "/poster",
          activePaths: ['/edit-poster/:posterId', '/registration-table/:posterId'],
          onClick: ()=>{
            if(isBasicUser()){
              alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', locale))
            }
          },
          disabled: ()=>{
            return !userCan('poster_channel') || isBasicUser()
          }
        },
        {
          label: __("Contacts", locale),
          path: "/contacts",
          activePaths: ['/contact-settings'],
          onClick: ()=>{
            if(isBasicUser()){
              alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', locale))
            }
          },
          disabled: ()=>{
            return !userCan('contact_channel') || isBasicUser()
          }
        },
      ],
    },
    {
      name: 'school',
      label: __("School Settings", locale),
      icon: "icon-account_balance",
      subMenus: [
        {
          label: __("Information", locale),
          default: true,
          path: "/school-information",
          disabled: ()=>{
            return !userCan('school_setting_channel')
          }
        },
        {
          label: __("Permissions", locale),
          path: "/school-settings",
          disabled: ()=>{
            return !userCan('group_perm_channel')
          }
        },
        {
          label: __("Website", locale),
          path: "/website",
          hide: ()=>{
            return  process.env.APP_ENV !== 'development' 
          },
          disabled: ()=>{
            return !userCan('website')
          }
        },
        {
          label: __("Terms and Conditions", locale),
          path: "/registration-agreement",
          disabled: ()=>{
            return !userCan('edit_school_setting')
          }
        },
      ]
    },
    // {
    //   name: 'suntower',
    //   label: 'Sun Tower',
    //   icon: "icon-account_balance",
    //   subMenus: [
    //     {
    //       label: 'Waiting List',
    //       default: true,
    //       path: "/waiting-list",
    //     },
    //     {
    //       label: 'Teacher Career',
    //       path: "/teacher-career",
    //     },
    //     {
    //       label: 'Payment Information',
    //       path: "/custom-payment-info",
    //     },
    //   ]
    // },
  ];
}



// WEBPACK FOOTER //
// ./src/containers/Main/get-menu-items.js